import { VALID_EMAIL_REGEX } from '@Utils/constants';

export const isValidEmail = (email: string) => VALID_EMAIL_REGEX.some((regex) => regex.test(email));
